import SpotlightConstants from '@/utils/enums/spotlightConstants';

// TODO understand why this index.js differes from the others in why it has a redirect parameter and lacks the category parameter
export default [
  {
    path: SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM'],
    redirect: '../highlights/siriusXmVehicleProgram',
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      headerStyleClasses: 'mb-0',
    },
  },
  {
    path: 'error',
    redirect: '../../error',
  },
].map(route => {
  const newRoute = { ...route };
  newRoute.meta = {
    ...newRoute.meta,
    productInformationPage: true,
  };
  return newRoute;
});
